/**
 * @module Services/Bff/Presenters/Credit
 * @desc Credit Presenter
 *
 */

import { formatMoney } from 'core/utilities';

import type { ResellerCreditResponse } from '../../@types';
import type { User } from 'core/domains';

/**
 * User Credit Presenter
 *
 */
export function creditPresenter(payload: ResellerCreditResponse): User['credit']['data'] {
  const {
    data: { available = 0 },
  } = payload;

  return {
    ...payload.data,
    available: formatMoney(available),
    availableNum: available,
  };
}
